import styles from "./Title.module.scss";
import { OwnBrand } from "@/utils/product/getOwnBrand";
import { ElementType } from "react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);
type Props = {
  /**
   * The title of the product.
   */
  title: string;
  /**
   * The own brand of the product.
   */
  ownBrand: OwnBrand;
  /**
   * Any other brand of the product.
   */
  otherBrand: string;
  /**
   * Used to override the element used to render the component.
   */
  element?: ElementType;
  /**
   * Used to remove h1 margin for beauty simplification work
   */
  simplifiedBeautyTitle?: boolean;
  /**
   * Boolean that represents if Responsive styling should be used
   */
  isResponsiveStylesEnabled?: boolean;
};

export function TitleUI({
  title,
  ownBrand,
  otherBrand,
  element = "h1",
  simplifiedBeautyTitle = false,
  isResponsiveStylesEnabled,
}: Props) {
  const Component = element;

  const headerClassNames = cx(styles.title, {
    simplifiedBeautyTitle: simplifiedBeautyTitle,
    titleResponsive: isResponsiveStylesEnabled,
  });

  return (
    <>
      <Component
        data-testid="product:title"
        className={headerClassNames}
        data-component="Title"
      >
        <div>
          {ownBrand === "jl_own_brand_anyday_legacy" && (
            <a className={styles.logoAnchor} href="/">
              <span
                data-testid="product:title:anyday"
                className={cx(styles.anydayLogo, {
                  anydayLogoResponsive: isResponsiveStylesEnabled,
                })}
              >
                ANYDAY
              </span>
            </a>
          )}

          {ownBrand === "jl_own_brand_anyday" && (
            <a className={styles.logoAnchor} href="/">
              <span
                data-testid="product:title:anyday"
                className={cx(styles.anydayLogo, {
                  anydayLogoResponsive: isResponsiveStylesEnabled,
                })}
              >
                <span className={styles.titlePrefix}>{`John Lewis `}</span>
                ANYDAY
              </span>
            </a>
          )}

          {ownBrand === "jl_own_brand_john_lewis" && (
            <span
              data-testid="product:title:johnlewis"
              className={cx(styles.johnLewisBrand, {
                logoResponsive: isResponsiveStylesEnabled,
              })}
            >
              John Lewis
            </span>
          )}

          {!ownBrand && otherBrand && (
            <span
              data-testid="product:title:otherBrand"
              className={cx(styles.otherBrand, {
                logoResponsive: isResponsiveStylesEnabled,
              })}
            >
              {otherBrand}
            </span>
          )}

          {title}
        </div>
      </Component>
    </>
  );
}
